export { default } from "./CartTable";



// WEBPACK FOOTER //
// ./src/components/sale/posSection/cartTable/index.js